module.exports = __webpack_public_path__ + "static/media/loading_spinner.63b548ad.svg";